export default __webpack_public_path__ + "e24af5c01c65d7916efb00ba6852973f.png";